<template>
	<div class="flex flex-col w-dvw min-h-(--min-height-custom-mobile) lg:min-h-(--min-height-custom) items-center gap-4">
		<span class="flex text-5xl md:text-7xl w-full justify-center items-center pt-8">Travel</span>
		<Divider class="w-32!" />
		<div class="flex flex-col items-center gap-2 w-19/20 lg:w-2/3">
			<Tabs
				value="0"
				class="size-full!"
			>
				<TabList
					class="bg-transparent!"
					:pt="{
						tabList: {
							class: 'justify-between! text-sm md:text-xl'
						}
					}"
				>
					<Tab
						value="0"
						class="w-1/3"
					>
						Accommodations
					</Tab>
					<Tab
						value="1"
						class="w-1/3"
					>
						Transportation
					</Tab>
					<Tab
						value="2"
						class="w-1/3"
					>
						Things to Do
					</Tab>
				</TabList>
				<TabPanels class="bg-transparent! size-full! text-(--primary-brown)! px-1! md:p-(--p-tabs-tabpanel-padding)!">
					<TabPanel value="0">
						<div class="flex flex-col w-full gap-2 text-center">
							<span>
								We have a room block at Ace Hotel which is close to the venue
								and offers easy access to public transportation.
								Click
								<NuxtLink
									to="https://reservations.acehotel.com/?&hotel=30176&arrive=2027-05-28&depart=2027-05-30&group=0527SCGO"
									target="_blank"
								>
									<span class="underline">here</span>
								</NuxtLink>
								for a link to the hotel’s booking site.
							</span>
							<span>
								We highly suggest getting a hotel as Airbnb, VRBO, and other short-term rental options are heavily restricted and regulated in NYC. If you plan to book through one of the services, verify that listings properly adhere to city guidelines so you do not lose your money. You can read more here:
								<NuxtLink
									to="https://www.nyc.gov/site/specialenforcement/stay-in-the-know/information-for-hosts.page"
									target="_blank"
									class="underline"
								>
									NYC Information for Hosts
								</NuxtLink>
							</span>
						</div>
					</TabPanel>
					<TabPanel value="1">
						<div class="flex flex-col w-full justify-center gap-8 text-center">
							<p>
								We recommend getting to New York Thursday, May 27 or Friday, May 28
								in case of any travel interruptions and to have time to explore the Big
								Apple. It will be Memorial Day Weekend, so plan on possible delays and
								busy airports.
							</p>
							<div class="flex flex-col items-center justify-center gap-2">
								<h1 class="text-lg md:text-3xl w-full justify-center text-center">
									Air Travel
								</h1>
								<div class="flex flex-col items-center justify-center w-full gap-6 text-sm md:text-base">
									<p>
										LaGuardia Airport (LGA) or John F. Kennedy International Airport
										(JFK) provide multiple forms of transportation to and from the
										airport and are the most convenient for travel. Both LGA and
										JFK are accessible by subway, taxi, Uber/Lyft, or shuttle.
										Using the subway is the most affordable option, but can be
										difficult if you have several bags or are not used to public
										transportation.
									</p>
									<p>
										Uber offers a reasonable shuttle to and from the airport to
										prominent points in Manhattan. If you choose to stay close to
										Times Square, Penn Station, or Grant Central Station, those are
										common routes for the shuttles. Otherwise, public transportation
										or Uber/Lyft are the best options.
									</p>
								</div>
							</div>
							<div class="flex flex-col items-center justify-center gap-2">
								<h1 class="text-lg md:text-3xl w-full justify-center text-center">
									Driving
								</h1>
								<p class="text-sm md:text-base">
									We do not recommend driving or renting a car. There is very
									limited parking throughout the city, and the parking available
									can be expensive. If you are driving in from a different state,
									we would recommend parking at your hotel and utilizing public
									transportation for the duration of your stay. You can also take
									taxis or Uber/Lyft.
								</p>
							</div>
						</div>
					</TabPanel>
					<TabPanel value="2">
						<ThingsToDo />
					</TabPanel>
				</TabPanels>
			</Tabs>
		</div>
	</div>
</template>

<script setup lang="ts">
	import ThingsToDo from "~/pages/ThingsToDo.vue";
	import {
		Divider
	} from "primevue";
	import Tabs from "primevue/tabs";
	import TabList from "primevue/tablist";
	import Tab from "primevue/tab";
	import TabPanels from "primevue/tabpanels";
	import TabPanel from "primevue/tabpanel";
</script>

<style scoped>

</style>